<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page bg-gray">
    <div class="content p-1">
        <aside>
            <all-accounts [lotId]="lotId" [language]="language" (accountChosen)="accountChosen($event)"></all-accounts>
        </aside>

        <main>
            <all-accounts-view [termsId]="termsId" [saleId]="saleId" [contactId]="accountId"></all-accounts-view>
        </main>
    </div>
</div>

<app-footer></app-footer>